export default "__VITE_ASSET__Cs76OC51__"